import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=7afcd875&"
import script from "./Simple.vue?vue&type=script&lang=js&"
export * from "./Simple.vue?vue&type=script&lang=js&"
import style0 from "./Simple.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports